module.exports = __webpack_public_path__ + "img/money.387a0e9c.png";